/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import LangContext from "../../contextProvider/LangContext";
import { Card, Form } from "antd";
import PageToolbar from "../../components/PageToolbar";
import DateTimePicker from "../../components/DateTimePicker";
import moment from "moment";
import ReportExcelBtn from "../../components/ReportExcelBtn";


class NotActiveCompanies extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            _endDate: moment().add(-3, "month").format("YYYY-MM-DD"),
        };

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(21401);
    }



    render() {
        const gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl", // dir: 'ltr'
            padding: "2% 2% 2% 2%",

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            flexDirection: 'column',
        };

        return (<div style={divStyle}>
            <Card title={(<PageToolbar title={gt(21403)} showsearch={false} actionButtons={[]} />)}
                bordered={true} style={{ width: 300 }}
                bodyStyle={{ padding: 16 }}
                headStyle={{ paddingLeft: 8, paddingRight: 8, marginTop: 4, height: 56 }}
                actions={[
                    <ReportExcelBtn
                        {...this.props}
                        btnStyle
                        btnType="primary"
                        btnText={gt(21405)}
                        api={"get_not_active_companies_excel"}
                        dataSend={this.state}
                        reportName={"NotActiveCompaniesFrom " + this.state._endDate}
                    />
                ]}>
                <Form.Item label={gt(21404)}>
                    <DateTimePicker
                        format="DD/MM/YYYY"
                        value={this.state._endDate}
                        onChange={e => { this.setState({ _endDate: e }) }}
                    />
                </Form.Item>
            </Card>


        </div>)
    }

}

export default NotActiveCompanies;